import { render } from "./AntdSpin.vue?vue&type=template&id=236c204a&scoped=true&ts=true"
import script from "./AntdSpin.vue?vue&type=script&lang=ts"
export * from "./AntdSpin.vue?vue&type=script&lang=ts"

import "./AntdSpin.vue?vue&type=style&index=0&id=236c204a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236c204a"]])

export default __exports__